(function ($) {
	"use strict";

	$.queryString = {
		parse: function (url, keepEmptyKeys) {
			var qo = {};

			keepEmptyKeys = keepEmptyKeys || false;

			if (url.indexOf("?") >= 0) {
				url.replace(
					new RegExp("([^?=&]+)(=([^&]*))?", "g"),
					function ($0, $1, $2, $3) {
						if ($3 || keepEmptyKeys) { qo[$1] = $3; }
					}
				);
			}

			return qo;

		},
		build: function (query, startSeparator) {
			var queryString = "",
				separator = typeof startSeparator === "undefined" ? "?" : startSeparator;

			for (var key in query) {
				if (query.hasOwnProperty(key)) {
					var value = query[key];

					if (value) {
						queryString += separator + key + "=" + value;

						if (separator !== "&") {
							separator = "&";
						}
					}
				}
			}

			return queryString;
		}
	};
})(jQuery);